<template>
  <div id="cup_teamDetail_teamData" v-show="currThemeObj">
    <div class="teamData_group" v-if="statArr">
      <div v-for="group in statArr" :key="group.key">
        <div class="group_label">
          <span :class="['letterSpa']" v-text="group.title"></span>
        </div>
        <div
          class="groupData_row"
          v-for="(row, rowIndex) in group.arr"
          :key="rowIndex"
        >
          <cup_svgCircle
            v-if="row.left"
            :currThemeObj="currThemeObj"
            :cx="cx"
            :cy="cy"
            :strokeWidth="strokeWidth"
            :svgDataArr="row.left"
            :keyArr="cup_svgCircle_keyArr"
            :totalName="row.totalName"
          ></cup_svgCircle>
          <div class="itemOther_targetList">
            <span
              class="targetList_item"
              v-for="(right, rightIndex) in row.right"
              :key="rightIndex"
            >
              <span
                class="targetItem_val"
                v-text="right.value ? right.value : '-'"
              ></span>
              <span class="targetItem_tip" v-text="right.name"></span>
            </span>
            <!-- <span class="targetList_item">
            <span class="targetItem_val">30</span>
            <span class="targetItem_tip">asdadadasda</span>
          </span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_svgCircle from '@components/platfromBase/football/cup_svgCircle.vue'
import { https_cup_teamDetailStat } from '@api/platfrom_football_api'
export default {
  name: 'cup_teamDetail_teamData',
  mixins: [cup_base_data_mixin],
  components: {
    cup_svgCircle,
  },
  data() {
    return {
      // svgDataArr: null,
      strokeWidthVw: 0.278,
      cxVw: 4.65,
      cyVw: 4.65,
      bodyWidth: 0,
      statArr: null,
      cup_svgCircle_keyArr: ['name', 'value'],
    }
  },
  created() {
    this.bodyWidth = window.innerWidth
      ? window.innerWidth
      : window.screen.width
      ? window.screen.width
      : 375
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    console.debug('route:', this.$route)
    const query = this.$route.query
    this.init(query)
    // window.setTimeout(() => {
    //   this.svgDataArr = [
    //     {
    //       val: 10,
    //       name: '11',
    //       key: 1,
    //     },
    //     {
    //       val: 0,
    //       name: '22',
    //       key: 2,
    //     },
    //     {
    //       val: 50,
    //       name: '22',
    //       key: 3,
    //     },
    //   ]
    // }, 10)
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    strokeWidth() {
      return Math.ceil((this.bodyWidth / 100) * this.strokeWidthVw)
    },
    cx() {
      return Math.ceil((this.bodyWidth / 100) * this.cxVw)
    },
    cy() {
      return Math.ceil((this.bodyWidth / 100) * this.cyVw)
    },
  },
  methods: {
    async init(query) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.getTeamDetailStat(query)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    onResizeEvent() {
      this.bodyWidth = document.body.clientWidth
    },
    async getTeamDetailStat(query) {
      await https_cup_teamDetailStat(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              const statArr = [
                {
                  key: 'keyStat',
                  title: '关键数据',
                  arr: [],
                },
                {
                  key: 'ofsStat',
                  title: '进攻数据',
                  arr: [],
                },
                {
                  key: 'dfsStat',
                  title: '防守数据',
                  arr: [],
                },
                {
                  key: 'orgStat',
                  title: '组织数据',
                  arr: [],
                },
              ]
              this.statArr = statArr.map((item) => {
                item.arr = res.data[item.key] ? res.data[item.key] : []

                return item
              })
              console.debug(this.statArr)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_teamDetail_teamData {
  padding: 2.778vw 0;
  .teamData_group {
    .group_label {
      position: relative;
      width: 100%;
      height: 3.472vw;
      background-image: var(--mixtmt_scheduleMatchList_dateBg);
      background-size: 100% auto;
      background-position: left top;
      background-repeat: no-repeat;
      span {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 21.55%;
        padding-top: 0.6%;
        font-size: 1.389vw;
        color: var(--mixtmt_whiteColor);
        text-align: center;
        font-weight: bold;
        &.letterSpa {
          letter-spacing: 0.4vw;
        }
      }
    }
    .groupData_row {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 3.472vw 0;
      width: 100%;
      height: auto;
      .itemOther_targetList {
        width: 55%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .targetList_item {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          width: calc(100% / 3);
          height: 7.22vw;
          padding-right: 0.972vw;
          .targetItem_val {
            font-size: 1.8vw;
            line-height: 2.22vw;
            color: var(--mixtmt_greyColor3);
            font-weight: bold;
          }
          .targetItem_tip {
            font-size: 1.11vw;
            color: var(--mixtmt_greyColor2);
            word-break: break-word;
          }
        }
      }
    }
  }
}
</style>
